import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const sipBookingApi = createAsyncThunk(
  "sipBooking",
  async ({partner_id="", name = "", startDate = "", endDate = "" }) => {
    const params = {};
    // Add name to the query if provided
    if (partner_id) {
      params.partner_id = partner_id;
    }
    if (name) {
      params.name = name;
    }
    // Add date range to the query if provided
    if (startDate) {
      params.startDate = startDate;
    }
    if (endDate) {
      params.endDate = endDate;
    }
    const response = await axiosInstance.get("/report/sipbooked", {
      params, // Pass the parameters to the API request
    });
    if (response) {
      return response.data;
    }
  }
);

const sipBookingSlice = createSlice({
  name: "sipBooking",
  initialState: {
    sipBooking: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(sipBookingApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(sipBookingApi.fulfilled, (state, action) => {
        state.sipBooking = action.payload;
        state.loading = false;
      })
      .addCase(sipBookingApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default sipBookingSlice.reducer;

